import {
  flattenCustomImage,
  flattenVideo,
  stripHTML,
} from '../../utils/helperTransforms.wp';

export function transformStaffDeepDive(data) {
  const options =
    data?.staffMember?.staffOptions ||
    data?.boardMember?.boardMemberOptions;
  if (!options) return null;

  const deepDiveHtml = options.deepDive || '';

  return {
    video: options.video ? flattenVideo(options.video) : false,
    videoThumbnail: options.videoThumbnail
      ? flattenCustomImage(options.videoThumbnail)
      : false,
    deepDiveHtml:
      (stripHTML(deepDiveHtml) || '').trim().length > 0 ? deepDiveHtml : '',
  };
}
